import { ReactElement } from "react"
import { LinkEmpty } from "../../link/link-empty"
import { Wrapper } from "../wrapper/wrapper"
import { ClinicProps } from "./clinic-props"
import * as S from './clinic-style'

const cards: Record<string, any> = {
  health: { image: '/uploads/clinic-humanizado.svg', title: 'Atendimento Humanizado', description: 'Atendimento de qualidade e humanizado.' },
  drugs: { image: '/uploads/clinic-agendamento.svg', title: 'Agendamento pelo App', description: 'Agendamento pelo App. É rápido, é prático.' },
  'exams-types': { image: '/uploads/clinic-exames-2.svg', title: 'Tipos de Exames', description: '4.000 tipos de exames.' },
  'exams-amount': { image: '/uploads/clinic-exames.svg', title: 'Exames por mês', description: 'Mais de 3 milhões de exames por mês.' },
  areas: { image: '/uploads/clinic-areas-medicas.svg', title: 'Áreas médicas', description: '43 áreas médicas.' },
  dentistry: { image: '/uploads/clinic-dentista.svg', title: 'Clinicas odontológicas', description: '450 clínicas com atendimento em medicina, odontologia e exames.' }
}

export function Clinic ({ id, mainLink, apiUrl, values, urlBuilder, params }: ClinicProps): ReactElement {
  return <S.Container id={id}>
    <Wrapper>
      <S.Wrapper>
        <S.Content>
          <h5>{values.title}</h5>
          <p>{values.description}</p>
          <S.Grid>
            {values.items.map(item => <S.Card>
              <img src={`${apiUrl}${cards[item].image}`} alt={cards[item].title} />
              <p>{cards[item].description}</p>
            </S.Card>)}
          </S.Grid>
          <LinkEmpty href={urlBuilder.build(mainLink, params)}>{values.buttonTitle}</LinkEmpty>
        </S.Content>
        <img src={values.image} alt={values.title} />
      </S.Wrapper>
      {values.responsible && <S.Responsible>
        Responsáveis Técnicos: {values.responsible}
      </S.Responsible>}
    </Wrapper>
  </S.Container >
}